import { ChakraBox, ProviderAvatarBlock } from '@equip.health/ui';
import { GetPatientDocumentProvidersResponse } from '~/store/services/documents';
import { UPLOAD_DATE_RANGE_OPTIONS } from '../constants/documentCenter.constants';
import { DateTime } from 'luxon';
import {
  basePatientTabsCollection,
  PatientTabs,
} from '../constants/patients.constants';
import { Path } from '~/routes/constants';
import type { History } from 'history';

export const getPatientDocumentUploadedByProviderOption = (
  provider: GetPatientDocumentProvidersResponse,
  id: string,
): ProviderUniversalSelectOption => {
  const legalName = {
    firstName: provider.firstName,
    lastName: provider.lastName,
  };

  const displayName = {
    firstName: provider.displayFirstName,
    lastName: provider.displayLastName,
  };

  const isDisplayName = displayName.firstName && displayName.lastName;

  return {
    ...provider,
    label: (
      <ChakraBox padding="6px 0px">
        <ProviderAvatarBlock
          avatarUrl={
            provider?.providerAvatar?.thumbnailUrl ||
            provider?.providerAvatar?.url
          }
          displayName={isDisplayName ? displayName : undefined}
          id={`${id}__AvatarBlock__${provider?.externalId}`}
          legalName={legalName}
          providerTypeName={provider?.providerType}
          shouldShowProviderType
          variant="standard"
        />
      </ChakraBox>
    ),
    primaryText: `${provider.displayFirstName || provider.firstName} ${provider.displayLastName || provider.lastName}`,
    value: provider?.externalId,
    userId: provider?.externalId,
  };
};

export const getDateRangeForOption = (optionValue: string) => {
  const now = DateTime.now();
  let from: DateTime;
  let to: DateTime;

  switch (optionValue) {
    case UPLOAD_DATE_RANGE_OPTIONS.LAST_7_DAYS:
      from = now.minus({ days: 6 }).startOf('day');
      to = now.endOf('day');
      break;

    case UPLOAD_DATE_RANGE_OPTIONS.LAST_30_DAYS:
      from = now.minus({ days: 29 }).startOf('day');
      to = now.endOf('day');
      break;

    case UPLOAD_DATE_RANGE_OPTIONS.THIS_YEAR:
      from = now.startOf('year').startOf('day');
      to = now.endOf('day');
      break;

    default:
      return null;
  }

  return {
    from: from.toISO(),
    to: to.toISO(),
  };
};

export const isDateRangeValid = (fromISO: string, toISO: string) => {
  return DateTime.fromISO(fromISO) <= DateTime.fromISO(toISO);
};

export const getFilterOptionLabel = (label: string) => {
  if (label === '(No tag added)') {
    return 'No tag added';
  }
  return label;
};

export const navigateToViewNote = (
  history: History<unknown>,
  document: PatientDocumentV2,
) => {
  history.push({
    pathname: `${Path.MAUD_PATIENTS}/${document.patientExternalId}/${
      basePatientTabsCollection[PatientTabs.NOTES].subPath
    }`,
    state: {
      documentId: document.documentExternalId,
      documentName: document.fileName,
      fromDocumentsTableRow: true,
    },
  });
};
